<template>
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                    <button class="btn btn-back" @click="backbtn()">
                        <span class="blind">뒤로가기</span>
                    </button>
                </div>
                <div class="title">
                    <!-- <a ><img src="../assets/images/common/img_logo.png" alt=""></a> -->
                    <span>Face Mapping Registration</span>
                </div>
            </div>
        </header>
        <!-- // header -->
        <gnb :gnb-on="gnbShow" @getChildGnbShow="getChildGnbShow" />
        <div class="gnb-dimmed" :class="gnbShow" @click="getChildGnbShow()" />

        <div id="content-wrap">
            <div id="contents">
                <!-- step info -->
                <div class="step-info-wrapper">
                    <div v-if="data.tunnelConstructionMethod === natm" class="container natm">
                        <ul>
                            <li class="on">
                                <span>STEP1.현장정보</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 2)">
                                <span>STEP2.이미지 매핑</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 3)">
                                <span>STEP3.이미지 크롭</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 4)">
                                <span>STEP4.막장 사진대지</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 5)">
                                <span>STEP5.강도정보</span>
                            </li>
                        </ul>
                    </div>
                    <div v-else class="container tbm">
                        <ul>
                            <li class="on">
                                <span>STEP1.현장정보</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 3)">
                                <span>STEP2.사진대지</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- // step info -->

                <div class="write-form-box">
                    <div class="container">
                        <div class="field-box">
                            <div class="label">
                                Construction Name
                            </div>
                            <div class="field">
                                <div class="select-box construction-area">
                                    <select ref="constructionNameValue" v-model="data.constructionName">
                                        <option
                                            v-for="(item, index) in constructionNameCodeList"
                                            :key="index"
                                            :value="item.code"
                                        >
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="field-box">
                            <div class="label">
                                File
                            </div>
                            <div class="field">
                                <input id="uploadFile" ref="uploadFile" type="file" @change="fileUpload" />
                                <button class="btn btn-upload" @click="fileUploadBtn">
                                    <span>파일 찾기</span>
                                </button>
                                <button class="btn btn-delete" @click="removeFile">
                                    <span>파일 삭제</span>
                                </button>
                                <span
                                    class="filename"
                                    style="display: inline-block;width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                                >
                                    {{ data.etcFileName }}
                                </span>
                            </div>
                        </div>

                        <div class="field-box">
                            <div class="label">
                                Location
                            </div>
                            <div class="field">
                                <div class="select-box">
                                    <select v-model="data.measureLocation">
                                        <option
                                            v-for="(item, index) in measureLocationCodeList"
                                            :key="index"
                                            :value="item.code"
                                        >
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>
                                <template v-if="false">
                                    <label v-for="(item, index) in measurePositionCodeList" :key="index" :value="index">
                                        <input
                                            v-model="measurePositionList"
                                            :value="item.name"
                                            type="checkbox"
                                            class="chk"
                                        />
                                        <span>{{ item.name }}</span>
                                    </label>
                                </template>
                            </div>
                        </div>

                        <div class="field-box">
                            <div class="label">
                                Station(STA NO.)
                            </div>
                            <div class="field">
                                <input ref="station" v-model="data.station" type="text" class="txt half" />
                                <span class="txt">{{ stationPrefix }} {{ data.station }}</span>
                            </div>
                        </div>

                        <div class="field-box">
                            <div class="label">
                                Rock Type
                            </div>
                            <div class="field">
                                <input ref="rockType" v-model="data.rockType" type="text" class="txt half" />
                                <div v-if="false" class="select-box">
                                    <select v-model="data.rockType" @change="rockTypeChange($event)">
                                        <option
                                            v-for="(item, index) in rockTypeCodeList"
                                            :key="index"
                                            :value="item.code"
                                        >
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="field-box">
                            <div class="label">
                                Geologist
                            </div>
                            <div class="field">
                                <input ref="geologist" v-model="data.geologist" type="text" class="txt half" />
                            </div>
                        </div>

                        <div v-if="false" class="field-box">
                            <div class="label">
                                Excavation(Total)
                            </div>
                            <div class="field flex">
                                <input v-model="data.excavation" type="number" class="txt short" value="150" />
                                <span>m,</span>
                                <span>(총</span>
                                <input v-model="data.excavationTotal" type="number" class="txt short" value="122.5" />
                                <span>m)</span>
                            </div>
                        </div>

                        <div class="field-box">
                            <div class="label">
                                Date
                            </div>
                            <div class="field flex">
                                <div class="date">
                                    <input v-model="data.investigationDay" type="date" class="txt date" />
                                </div>
                                <template v-if="false">
                                    <div class="select-box short">
                                        <select v-model="data.investigationTimeH" class="auto">
                                            <option v-for="(item, index) in timeHArray" :key="index" :value="item">
                                                {{ item }}
                                            </option>
                                        </select>
                                    </div>
                                    <span>시</span>
                                    <div class="select-box short">
                                        <select v-model="data.investigationTimeM">
                                            <option v-for="(item, index) in timeMArray" :key="index" :value="item">
                                                {{ item }}
                                            </option>
                                        </select>
                                    </div>
                                    <span>분</span>
                                </template>
                            </div>
                        </div>

                        <div class="field-box">
                            <div class="label">
                                Tunnel Construction Method
                            </div>
                            <div class="field">
                                <div class="select-box">
                                    <select ref="tunnelConstructionMethodName" v-model="data.tunnelConstructionMethod">
                                        <option
                                            v-for="(item, index) in tunnelConstructionMethodCodeList"
                                            :key="index"
                                            :value="item.code"
                                        >
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="container">
                        <div class="field-box">
                            <div class="label">
                                암판정위원회 개체 여부
                            </div>
                            <div class="field">
                                <input
                                    id="judgementYn1"
                                    v-model="data.judgementYn"
                                    type="radio"
                                    class="rdo"
                                    value="N"
                                />
                                <label for="judgementYn1"><span>아니요</span></label>
                                <input
                                    id="judgementYn2"
                                    v-model="data.judgementYn"
                                    type="radio"
                                    class="rdo"
                                    value="Y"
                                />
                                <label for="judgementYn2"><span>예</span></label>
                            </div>
                        </div>
                        <div class="field-box">
                            <div class="label">
                                비대면 여부
                            </div>
                            <div class="field">
                                <input id="noFaceYn1" v-model="data.nonFaceYn" type="radio" class="rdo" value="N" />
                                <label for="noFaceYn1"><span>아니요</span></label>
                                <input id="noFaceYn2" v-model="data.nonFaceYn" type="radio" class="rdo" value="Y" />
                                <label for="noFaceYn2"><span>예</span></label>
                            </div>
                        </div>
                        <div class="field-box">
                            <div class="label">
                                회의 예정 시간
                            </div>
                            <div class="field flex">
                                <div class="date">
                                    <input v-model="data.judgementDay" type="date" class="txt date" />
                                </div>

                                <div class="select-box short">
                                    <select v-model="data.judgementTimeH" class="auto">
                                        <option v-for="(item, index) in timeHArray" :key="index" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                                <span>시</span>
                                <div class="select-box short">
                                    <select v-model="data.judgementTimeM">
                                        <option v-for="(item, index) in shortTimeArray" :key="index" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                                <span>분</span>
                            </div>
                        </div>
                        <div class="field-box">
                            <div class="label">
                                암판정 요청 메시지
                            </div>
                            <div class="field">
                                <input v-model="data.judgementMessage" type="text" class="txt full" />
                            </div>
                        </div>
                    </div>

                    <div class="container">
                        <div class="field-box">
                            <div class="label">
                                결재라인 설정
                            </div>
                            <div class="field flex approval-line-field">
                                <div class="select-box">
                                    <select v-model="data.groupNo" @change="onChangedApprovalLine">
                                        <option value="0">
                                            결재라인을 설정하세요.
                                        </option>
                                        <option
                                            v-for="(item, index) in templateList"
                                            :key="index"
                                            :value="item.groupNo"
                                        >
                                            {{ item.templateName }}
                                        </option>
                                    </select>
                                </div>
                                <div class="approval-line-preview">
                                    <span v-for="(data, index) in approvalList" :key="index" class="volume-box">
                                        {{ data.name }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="btn-wrapper bottom-fixed">
                        <button type="button" class="btn btn-save" @click="save()">
                            <span>저장 및 다음으로</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </body>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ApprovalApi from '../api/ApprovalApi';
import CodeApi from '../api/CodeApi';
import FacemappingApi from '../api/FacemappingApi';
import FileApi from '../api/FileApi';
import { AUTH, COMM_CODE, CONSTRUCTION, CONSTRUCTION_NM, TUNNEL_CONSTRUCTION, TYPE } from '../const';
import MutationTypes from '../store/MutationTypes';
import gnb from './layout/gnb.vue';

export default {
    name: 'Step1',
    components: {
        gnb
    },
    data: () => {
        return {
            data: {
                id: null,
                investigationTimeH: '00',
                investigationTimeM: '00',
                measureLocation: '010001',
                rockType: '013001',
                rockTypeName: 'PT-1',
                etcFile: '',
                etcFileName: '',
                tunnelConstructionMethod: TUNNEL_CONSTRUCTION.NATM,
                investigationDay: new Date().toISOString().substr(0, 10),
                judgementTimeH: '00',
                judgementTimeM: '00',
                groupNo: 0
            },
            measureLocationCodeList: {},
            rockTypeCodeList: {},
            measurePositionCodeList: {},
            tunnelConstructionMethodCodeList: {},
            constructionNameCodeList: [],
            measurePositionList: [],
            timeHArray: [],
            timeMArray: [],
            shortTimeArray: ['00', '30'],
            stationPrefix: 'STA NO.',
            gnbShow: '',
            natm: TUNNEL_CONSTRUCTION.NATM,
            templateList: [],
            approvalList: []
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.showLoading();
        //this.$store.dispatch('showLoading');
        //  this.hideLoading();
    },
    created() {
        this.data.id = this.$route.params.id;
        this.hideLoading();
    },
    async mounted() {
        //ScreenHelper.setPortrait();
        this.codeSettign(COMM_CODE.measureLocation);
        this.codeSettign(COMM_CODE.rockType);
        this.codeSettign(COMM_CODE.measurePosition);
        this.codeSettign(COMM_CODE.tunnelConstruction);

        const res = await ApprovalApi.getTemplateList();
        this.templateList = res.content;

        for (var i = 0; i < 60; i++) {
            var _target = i;
            _target = _target < 10 ? '0' + _target : _target;
            if (_target < 24) this.timeHArray.push(_target);
            this.timeMArray.push(_target);
        }

        if (localStorage.getItem(TYPE) === AUTH.admin) {
            this.codeSettign(COMM_CODE.constructionName);
        } else {
            this.constructionNameCodeList.push({
                name: localStorage.getItem(CONSTRUCTION_NM),
                code: localStorage.getItem(CONSTRUCTION)
            });
            this.data.constructionName = localStorage.getItem(CONSTRUCTION);
        }

        if (this.data.id) {
            this.dataObj();
        } else {
            this.data.geologist = localStorage.getItem('name');
        }
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        backbtn() {
            this.$router.go(-1);
        },
        nextStep(tunnelConstructionMethod, step) {
            this.$store.commit(MutationTypes.SET_IS_DATA, this.data);

            if (this.data.id !== null) {
                if (step === 5) {
                    this.$router.push({ path: `/step5/` + this.data.constructionName + `/${this.data.id}` });
                } else {
                    if (tunnelConstructionMethod === TUNNEL_CONSTRUCTION.NATM)
                        this.$router.push({ path: `/step` + step + `/${this.data.id}` });
                    else this.$router.push({ path: `/step` + step + `TBM/${this.data.id}` });
                }
            }
        },
        dataObj() {
            this.showLoading();

            FacemappingApi.detail(this.data.id).then(res => {
                this.data = res.content;
                this.measurePositionList = res.content.measurePosition.split(',');
                //this.data.constructionName = this.data.constructionName;
                //this.data.constructionNameValue = this.data.constructionNameValue;
                if (this.data.investigationTime) {
                    var investigationTimeArray = this.data.investigationTime.split(':');
                    this.data.investigationTimeH = investigationTimeArray[0];
                    this.data.investigationTimeM = investigationTimeArray[1];
                }

                if (this.data.judgementTime) {
                    var judgementTimeArray = this.data.judgementTime.split(':');
                    this.data.judgementTimeH = judgementTimeArray[0];
                    this.data.judgementTimeM = judgementTimeArray[1];
                } else {
                    this.data.judgementTimeH = '00';
                    this.data.judgementTimeM = '00';
                }

                this.hideLoading();
            });

            ApprovalApi.getLine(this.data.id).then(res => {
                this.approvalList = res.content;
            });
        },
        codeSettign(code) {
            CodeApi.subCodeList(code, 2).then(res => {
                if (code === COMM_CODE.measureLocation) this.measureLocationCodeList = res.content;
                if (code === COMM_CODE.rockType) this.rockTypeCodeList = res.content;
                if (code === COMM_CODE.measurePosition) this.measurePositionCodeList = res.content;
                if (code === COMM_CODE.tunnelConstruction) this.tunnelConstructionMethodCodeList = res.content;
                if (code === COMM_CODE.constructionName) {
                    this.constructionNameCodeList = res.content;
                    this.data.constructionName = res.content[0].code;
                }
            });
        },
        save() {
            if (!this.data.station) {
                alert('Station을 입력하세요');
                this.$refs.station.focus();
                return;
            }

            //const regexStation = /^\d+\+\d{1,3}(\.\d+)?$/;
            /* const regexStation = /^[^\s]+\s\d+\+\d{1,3}(\.\d+)?$/;
            if (!regexStation.test(this.data.station)) {
                alert("Station 형식이 잘못되었습니다. '한글(생략가능) 0+000' 형식으로 입력하세요");
                this.$refs.station.focus();
                return;
            }
            */

            if (!this.data.geologist) {
                alert('Geologist를 입력하세요');
                this.$refs.geologist.focus();
                return;
            }
            if (!this.data.investigationDay) {
                alert('Date를 입력하세요');
                this.$refs.geologist.focus();
                return;
            }

            ///this.data.investigationTime = this.data.investigationTimeH + ':' + this.data.investigationTimeM;
            this.data.investigationTime = '00:00';
            this.data.investigationDay = this.data.investigationDay.replace(/-/gi, '');

            this.data.judgementTime = this.data.judgementTimeH + ':' + this.data.judgementTimeM;
            if (this.data.judgementDay) this.data.judgementDay = this.data.judgementDay.replace(/-/gi, '');

            var measurePosition = '';
            $.each(this.measurePositionList, function(idx) {
                if (idx !== 0) {
                    measurePosition += ',' + this;
                } else {
                    measurePosition += this;
                }
            });
            this.data.measurePosition = measurePosition;

            var constructionNameValue = this.$refs.constructionNameValue;
            this.data.constructionNameValue = constructionNameValue.options[constructionNameValue.selectedIndex].text;
            var tunnelConstructionMethodName = this.$refs.tunnelConstructionMethodName;
            this.data.tunnelConstructionMethodName =
                tunnelConstructionMethodName.options[tunnelConstructionMethodName.selectedIndex].text;

            this.data.meter = this.parseStationNumber(this.data.station);
            this.showLoading();

            FacemappingApi.saveSiteInfo(this.data).then(res => {
                this.hideLoading();
                this.data.id = res.content;
                ApprovalApi.postLine({ id: this.data.id, groupNo: this.data.groupNo }).then(() => {
                    if (this.data.tunnelConstructionMethod === TUNNEL_CONSTRUCTION.NATM)
                        this.$router.push({ path: `/step2/${this.data.id}` });
                    else this.$router.push({ path: `/step3TBM/${this.data.id}` });
                });
            });
        },
        rockTypeChange(event) {
            this.data.rockType = event.target.value;
            this.data.rockTypeName = event.target.options[event.target.options.selectedIndex].text;
        },
        fileUploadBtn() {
            const fileInputElement = this.$refs.uploadFile;
            fileInputElement.click();
        },
        async fileUpload() {
            const fileObject = this.$refs.uploadFile.files[0];
            const formData = new FormData();

            formData.append('file_id', '');
            formData.append('file_no', 1);
            formData.append('file', fileObject);
            this.showLoading();
            const fileRes = await FileApi.fileUpload(formData, 'doc');
            this.data.etcFile = fileRes.content[0].id.fileId;
            this.data.etcFileName = fileRes.content[0].name;
            this.hideLoading();
        },
        removeFile() {
            this.data.etcFile = '';
            this.data.etcFileName = '';
        },
        onChangedApprovalLine() {
            //var selectedValue = $(this).val();
            var selectedValue = this.data.groupNo;
            if (selectedValue === '0') {
                this.approvalList = [];
            } else {
                this.templateList.forEach(item => {
                    if (item.groupNo === selectedValue) {
                        console.log(item);
                        this.approvalList = item.members;
                    }
                });
            }
        },
        parseStationNumber(staString) {
            // 정규 표현식으로 "STA NO." 부분을 무시하고 km와 미터 값을 추출합니다.
            // `\+`를 포함하거나 포함하지 않는 경우 모두 고려합니다.
            //const regex = /(\d+)\+?(\d*\.?\d*)/i;
            //const regexStation = /^\d+\+\d{1,3}(\.\d+)?$/;
            //const regex = /^[^\s]+\s\d+\+\d{1,3}(\.\d+)?$/;

            //const match = staString.match(regex);
            const match = true;
            if (match) {
                // km 부분이 비어 있으면 0으로 간주합니다.
                let km = 0;
                let meters = 0;

                if (match[2]) {
                    // "+" 기호를 포함하고 뒤에 숫자가 있다면
                    km = parseInt(match[1], 10);
                    meters = parseFloat(match[2]);
                } else {
                    // "+" 기호 없이 숫자만 있다면
                    meters = parseFloat(match[1]);
                }

                console.log(`sta: ${staString}, km: ${km}, meters: ${meters}`);
                // 전체 미터 계산: km * 1000 + meters
                const totalMeters = km * 1000 + meters;
                return totalMeters;
            }
            return 0;
        }
    }
};
</script>
